var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_511_495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.37467 8.23117C1.31912 8.08151 1.31912 7.91688 1.37467 7.76721C1.91576 6.45524 2.83421 5.33347 4.01361 4.54412C5.193 3.75476 6.58022 3.33337 7.99939 3.33337C9.41856 3.33337 10.8058 3.75476 11.9852 4.54412C13.1646 5.33347 14.083 6.45524 14.6241 7.76721C14.6797 7.91688 14.6797 8.08151 14.6241 8.23117C14.083 9.54314 13.1646 10.6649 11.9852 11.4543C10.8058 12.2436 9.41856 12.665 7.99939 12.665C6.58022 12.665 5.193 12.2436 4.01361 11.4543C2.83421 10.6649 1.91576 9.54314 1.37467 8.23117Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99884 9.99901C9.1033 9.99901 9.99865 9.10367 9.99865 7.9992C9.99865 6.89474 9.1033 5.99939 7.99884 5.99939C6.89437 5.99939 5.99902 6.89474 5.99902 7.9992C5.99902 9.10367 6.89437 9.99901 7.99884 9.99901Z",
    stroke: "#F0E1CE",
    strokeWidth: 1.33321,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_511_495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9985,
    height: 15.9985,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e4d925a30f08ed309a183fbb2aa951c2.svg";
export { ForwardRef as ReactComponent };